<script lang="ts" setup>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const props = defineProps<{
  modelValue: string | undefined,
  minDate?: string,
  disabled?: boolean, // Properti disabled opsional
}>();

const emit = defineEmits<{ (e: 'update:modelValue', value: string): void }>();

const selectedValue = ref(props.modelValue || '');

watch(() => props.modelValue, (newValue) => {
  selectedValue.value = newValue || '';
});

const updateValue = (value: string) => {
  const date = new Date(value);
  const formattedValue = date.toISOString().split('T')[0];
  emit('update:modelValue', formattedValue);
};

const defaultMinDate = new Date().toISOString().split('T')[0];
const minDate = computed(() => props.minDate || defaultMinDate);

const isDisabled = computed(() => props.disabled ?? false); // Gunakan nilai default false jika disabled tidak disediakan
</script>

<template>
  <div>
    <VueDatePicker
      id="date"
      v-model="selectedValue"
      input-class="form-control"
      :enable-time-picker="false"
      :min-date="minDate"
      :disabled="isDisabled"
      position="left"
      @update:modelValue="updateValue"
      locale="id"
      :auto-apply="true"
      :month-change-on-scroll="false"
      arrow-navigation
      :format="date => date ? date.toLocaleDateString('id-ID', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' }) : ''"
    />
  </div>
</template>

<style scoped></style>
